import { createIdentitiesFetcher } from '../contexts/Fetcher';
import { apiAuth } from '../resources/api/apiAuth';

const { useGet2FAMethods } = apiAuth;

export const MFAMethodsFetcher = createIdentitiesFetcher(() => useGet2FAMethods().execute);
